

















import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import IsMainPageMixin from '@/mixins/isMainPage';
import IsPfdodMixin from '@/mixins/isPfdodCheck';
import IsProfile from '@/mixins/isProfile';

@Component
export default class ComponentsTopline extends Mixins(
  IsMainPageMixin,
  IsPfdodMixin,
  IsProfile
) {
  @Prop({ type: Number, default: 4 })
  hideSpeed: number;

  @Prop({ type: String, default: '#6153ac' })
  colorMain: string;

  offSet: number = 0;
  addMenuHeigth: number = 52;
  isShowAddMenu: boolean = true;
  totalHeight: number = this.$slots.line ? 80 : this.addMenuHeigth;

  get isAddMenu() {
    return this.$slots.addMenu;
  }

  get addMenuToggle() {
    return this.isAddMenu && !this.isProfile;
  }

  get offSetRatio() {
    return this.offSet / this.hideSpeed;
  }

  get pfdodHeightLine() {
    return this.isPfdodModule ? 'height: 28px' : 'height: 0';
  }

  get heightTop() {
    const {
      offSetRatio,
      totalHeight,
      addMenuToggle,
      isShowAddMenu,
      pfdodHeightLine,
    } = this;
    return addMenuToggle && isShowAddMenu
      ? `height: ${totalHeight - offSetRatio}px`
      : pfdodHeightLine;
  }

  get translateAddMenu() {
    const { isShowAddMenu, offSetRatio, addMenuHeigth } = this;
    return isShowAddMenu
      ? `transform: translateY(${0 - this.offSetRatio}px);`
      : `transform: translateY(-${addMenuHeigth}px);`;
  }

  get styleMenu() {
    const { colorMain, translateAddMenu } = this;
    return colorMain !== '#6153ac'
      ? `${translateAddMenu} background-color: ${colorMain};`
      : translateAddMenu;
  }

  @Watch('isMainPage')
  listenerTo(val: boolean) {
    if (val) {
      this.offSet = 0;
      this.scrollListen();
    } else {
      this.noScrollListen();
    }
  }

  @Watch('offSetRatio')
  showAddMenu(val: number) {
    if (val == 0) this.isShowAddMenu = true;
  }

  mounted() {
    if (this.addMenuToggle) {
      this.scrollListen();
    }
  }

  beforeDestroy() {
    this.noScrollListen();
  }

  scrollListen() {
    window.addEventListener('scroll', this.onScroll);
  }

  noScrollListen() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const { offSetRatio, addMenuHeigth } = this;
    this.offSet = window.pageYOffset;
    this.isShowAddMenu = !(offSetRatio > addMenuHeigth);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/topline/Topline.vue